export function getUrlParam(name: string) {
  const url = new URL(window.location.toString())
  return url.searchParams.get(name)
}

export function getAccountIdFromUrlPath() {
  const match = RegExp(/(?:\/forex\/)(\d+)/).exec(window.location.pathname)
  if (match) {
    return match[1]
  }

  return null
}
